import React, { useState } from "react";
import { CloudLightning, CaretDown, ArrowSquareOut } from "@phosphor-icons/react";

export default function LightningCard({ countyName, bounds }) {
  const [open, setOpen] = useState(false);
  const lat = bounds ? (bounds.min_lat + bounds.max_lat) / 2 : 48.4;
  const lon = bounds ? (bounds.min_lon + bounds.max_lon) / 2 : -119.5;
  const embedUrl = `https://map.blitzortung.org/#10/${lat.toFixed(4)}/${lon.toFixed(4)}`;

  return (
    <section data-testid="lightning-card" className="border-b border-tac-border bg-tac-surface/40">
      <button
        type="button"
        data-testid="lightning-toggle"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-4 py-2.5 text-left hover:bg-tac-surface/60 transition-colors"
      >
        <CloudLightning size={14} weight="fill" className="text-tac-warning" />
        <span className="text-[12px] uppercase tracking-[0.15em] font-bold text-tac-text">
          Live Lightning Strikes
        </span>
        <CaretDown
          size={12}
          weight="bold"
          className={`text-tac-dim transition-transform ml-auto ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="px-3 pb-3">
          <div className="border border-tac-border rounded-sm overflow-hidden bg-black">
            <iframe
              data-testid="lightning-iframe"
              src={embedUrl}
              title={`Live lightning strikes near ${countyName || "county"}`}
              className="w-full h-[320px] block"
              loading="lazy"
              sandbox="allow-scripts allow-same-origin"
            />
          </div>
          <div className="flex items-center justify-between mt-1.5 text-[11px] font-mono-tac text-tac-faint">
            <span>Lightning data by Blitzortung.org and contributors</span>
            <a
              href={`https://www.lightningmaps.org/?lang=en#y=${lat.toFixed(4)};x=${lon.toFixed(4)};z=10;t=3;d=2;dl=2;dc=0;`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="lightning-fullmap-link"
              className="inline-flex items-center gap-1 font-bold uppercase tracking-wider text-tac-dim hover:text-tac-text"
            >
              LightningMaps.org <ArrowSquareOut size={10} weight="bold" />
            </a>
          </div>
        </div>
      )}
    </section>
  );
}
